import { searchBaseConfig } from '@otp/utils/baseDataConfig';

export default {
    configuration: true,
    searchList: {
        searchTxt: [
            {
                name: '客户订单号',
                value: 'customerOrderNo',
                type: 'input',
                unfold: true,
                span: 3
            },
            {
                name: '来源系统',
                value: 'sourceSystem',
                type: 'select',
                unfold: true,
                filterable: true,
                optionNum: 'SOURCE_SYSTEM',
                options: [],
                span: 3
            },
            {
                name: '时间范围',
                value: 'createTime',
                type: 'time',
                unfold: true,
                format: 'yyyy-MM-dd HH:mm:ss',
                timeNum: 6,
                span: 6
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        clickModify: true,
        selectBtn: false,
        leftWidth: 100,
        height: 400,
        leftOperation: false,
        columns: [
            {
                label: '客户订单号',
                prop: 'customerOrderNo',
                sort: true,
                width: 200
            },
            {
                label: '客户名称',
                prop: 'customerName',
                sort: true,
                width: 140
            },
            {
                label: '来源系统',
                prop: 'sourceSystem',
                type: 'select',
                optionNum: 'SOURCE_SYSTEM',
                width: 110,
                sort: true
            },
            {
                label: '承运商',
                prop: 'carrierName',
                sort: true,
                width: 140
            },
            {
                label: '订单类型',
                prop: 'upperOrderType',
                type: 'select',
                optionNum: 'ORDER_TYPE',
                width: 110,
                sort: true
            },
            {
                label: '上游客户编码',
                prop: 'upperCustomerCode',
                width: 140,
                sort: true
            },
            {
                label: '服务平台',
                prop: 'siteName',
                width: 160,
                sort: true
            },
            {
                label: '仓库',
                prop: 'whName',
                value: 'whCode',
                width: 160,
                sort: true
            },
            {
                label: '快递单号',
                prop: 'expressNo',
                width: 140,
                sort: true
            },
            {
                label: '状态编码',
                prop: 'nodeCode',
                width: 110,
                sort: true
            },
            {
                label: '状态名称',
                prop: 'nodeCame',
                width: 110,
                sort: true
            },
            {
                label: '操作时间',
                prop: 'operationTime',
                width: 160,
                sort: true
            },
            {
                label: '操作时间',
                prop: 'updateTime',
                width: 160,
                sort: true
            },
            {
                label: '创建时间',
                prop: 'createTime',
                width: 160,
                sort: true
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    },
    // 高级搜索配置项
    searchTotalTitle: [
        {
            ...searchBaseConfig.customer,
            dimensionType: 'CUSTOMER',
            unfold: true,
            'advanceConfig': [
                { 'prop': 'pmCodeOrNameCn', 'value': '客户编码或名称' }
            ],
            'advancePlaceholder': "支持模糊查询",
        },
        {
            ...searchBaseConfig.site,
            'advanceConfig': [
                { 'prop': 'escoCompanyNoOrNameCn', 'value': '服务平台编码或名称' },
            ],
            'advancePlaceholder': "支持模糊查询",
            'tableConfig': [
                { 'prop': 'siteCode', 'value': '服务平台编码' },
                { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称', 'displayName': true },
                { 'prop': 'companyCode', 'value': '分公司编码' },
                { 'prop': 'companyName', 'value': '分公司名称' }
            ],
            'advanceUrl': '/esCompany/searchSiteV2?escoCompanyType=P',

         },
        { ...searchBaseConfig.wh,
            advanceConfig: [
                { prop: 'codeAndName', value: '仓库编码或名称' }
            // { prop: 'cdwhName', value: '仓库名称' },
            // { prop: 'whCode', value: '仓库编码' }
            ]
        },
        { ...searchBaseConfig.carrierCode },
        {
            name: '快递单号',
            value: 'expressNo',
            type: 'input',
            span: 4
        },
        {
            name: '来源系统',
            value: 'sourceSystem',
            type: 'select',
            filterable: true,
            optionNum: 'SOURCE_SYSTEM',
            options: []
        },
        {
            name: '节点状态',
            value: 'nodeCode',
            type: 'select',
            optionNum: 'TPL_ORDER_STATUS',
            filterable: true,
            unfold: true,
            options: [],
            span: 4
        }
    ]
};
